export const extractAuthorNames = bookAuthorsObj => {
    if (!bookAuthorsObj)
        return '';
    else if (bookAuthorsObj.author && Array.isArray(bookAuthorsObj.author) && bookAuthorsObj.author.length > 0 && bookAuthorsObj.author[0].name)
        return bookAuthorsObj.author.map(({ name }, i) => name).join(' & ');
}